import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ICreateOrderRequest, IPayPalConfig } from 'ngx-paypal/lib/models/paypal-models';
import { ZoomService } from '../../services/zoom-service.component';
import { LoadingModalService } from '../loading-modal/loading-modal.service';
import { MailService } from '../via-mail/mail-service';

@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.css']
})
export class PaypalComponent implements OnInit {
  @ViewChild('payPalModal') paypalModal: ModalDirective;

  @Output() success: EventEmitter<string>;
  @Output() fail: EventEmitter<void>;

  public title: string = "Kurstitel";

  public payPalConfig?: IPayPalConfig;

  public ppUrl: string;
  public ppClientId: string;
  public ppSecret: string;

  public ppAccessToken: string;

  public invoiceURI: string;
  public invoiceLinkforCustomer: string;

  public payer: string;

  public price: string;
  public netPrice: string;
  public tax: string;
  public vendorMail: string;

  public firstName: string;
  public lastName: string;
  public destination: string;
  public meetingId: string;
 
  constructor(
    private http: HttpClient,
    private loadingModalService: LoadingModalService,
    private zoomService: ZoomService,
    private mailService: MailService,
  ) {
    this.success = new EventEmitter<string>();
    this.fail = new EventEmitter<void>();
  }

  ngOnInit(): void {
    // ////////
    // TEST
    // ////////
    // this.price = '0.02';
    // this.netPrice = '0.01';
    // this.tax = '50';

    // this.ppUrl = 'https://api-m.sandbox.paypal.com'
    // this.vendorMail = 'reha@business.example.com'
    // this.ppClientId = 'ASM9vjFloGR8-MJwXYyf8HCzrBSPruXMbcqZmMYqR1F7e-nX-jF1Q1Jg5BBQhkFXg1MEuX9U9e8OaLkW';
    // this.ppSecret = 'ELBn9RJjZGGVeCjN2KjnEKZK-sofP-6NvS6QaCJEvebPBVfXvjCJIoz21dNaKPApITt_xFka6ND_haz0';

    // ////////
    // LIVE
    // ////////
    this.price = '9.98';
    this.netPrice = '8.39';
    this.tax = '19';

    this.ppUrl = 'https://api-m.paypal.com'
    this.vendorMail = 'info@reha-sportstudio.de'
    this.ppClientId = 'AbUAcGYIVqLUjffumnjwZn3LGFegnnr1-nLmKptN6cqZI0y_D1fJuGpJGETxt9eBsUcGzb3sJyp5vpqh';
    this.ppSecret = 'EPg4xSEduiJJPwm0vnFRXk_aWZ-cf76kVUPHjM9mPxKinTC3mKZc6EN3iblaf3fHYlCZaaYFXA9sbazS';

    this.getToken();
    this.initConfig();
  }

  private getToken() {
    let key = btoa(this.ppClientId + ':' + this.ppSecret);

    let headers = new HttpHeaders({
      "Accept": "application/json",
      "Accept-Language": "de_DE",
      'Authorization': 'Basic ' + key,
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    this.http.post<any>(this.ppUrl + '/v1/oauth2/token', "grant_type=client_credentials", { headers: headers })
      .subscribe(data => {
        this.ppAccessToken = data.access_token;
      })
  }

  private initConfig(): void {
    this.payPalConfig = {
      currency: 'EUR',
      clientId: this.ppClientId,

      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [
          {
            amount: {
              currency_code: 'EUR',
              value: this.price,
              breakdown: {
                item_total: {
                  currency_code: 'EUR',
                  value: this.price
                }
              }
            },
            items: [
              {
                name: this.title,
                quantity: '1',
                category: 'DIGITAL_GOODS',
                unit_amount: {
                  currency_code: 'EUR',
                  value: this.price,
                },
              }
            ]
          }
        ]
      },
      advanced: {
        commit: 'true'
      },
      style: {
        label: 'paypal',
        layout: 'vertical'
      },
      onApprove: (data, actions) => {
        console.log('onApprove - transaction was approved, but not authorized', data, actions);
        actions.order.get().then(details => {
          console.log('onApprove - you can get full order details inside onApprove: ', details)
          this.getNextInvoiceNumber();
          this.payer = Object(details)["payer"];
          this.paypalModal.hide();
          this.loadingModalService.incrementLoading();
        });
      },
      onClientAuthorization: (data) => {
        console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
        console.log("SUCCESS");
      },
      onCancel: (data, actions) => {
        console.log('OnCancel', data, actions);
        this.fail.emit();
      },
      onError: err => {
        console.log('OnError', err);
        this.fail.emit();
      },
      onClick: (data, actions) => {
        console.log('onClick', data, actions);
      },
    };
  }

  private getNextInvoiceNumber() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.ppAccessToken,
    });

    this.http.post<any>(this.ppUrl + '/v2/invoicing/generate-next-invoice-number', undefined, { headers: headers })
      .subscribe(data => {
        let invoiceNumber = Object(data)["invoice_number"];
        this.createDraftInvoice(invoiceNumber);
      })
  }

  private createDraftInvoice(invoiceNumber) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.ppAccessToken,
    });

    console.log(this.payer)

    let address = Object(this.payer)["address"];
    let mail = Object(this.payer)["email_address"];
    let name = Object(this.payer)["name"];
    let given_name = Object(name)["given_name"];
    let surname = Object(name)["surname"];

    let today = new Date(Date.now()).toISOString().slice(0, 10);
    let due_date = new Date(Date.now() + 1000 * 60 * 60 * 24 * 10).toISOString().slice(0, 10);

    this.destination = mail;
    this.firstName = given_name;
    this.lastName = surname;


    let invoice = '{ "detail": { "invoice_number": "' + invoiceNumber + '", "invoice_date": "' + today + '", "currency_code": "EUR", "note": "Danke für den Einkauf.", "payment_term": { "term_type": "NET_10", "due_date": "' + due_date + '" } }, "invoicer": { "name": { "given_name": "REHA Sportstudio", "surname": "Schwäbisch Hall" }, "address": { "address_line_1": "Steinbeisweg 36/2", "address_line_2": "Schwäbisch Hall", "postal_code": "74523", "country_code": "DE" }, "email_address": "' + this.vendorMail + '", "phones": [ { "country_code": "049", "national_number": "0791856325", "phone_type": "MOBILE" } ], "website": "www.reha-sportstudio.de", "logo_url": "https://example.com/logo.PNG" }, "primary_recipients": [ { "billing_info": { "name": { "given_name": "' + given_name + '", "surname": "' + surname + '" }, "address": { "address_line_1": "1234 Main Street", "admin_area_2": "Anytown", "postal_code": "98765"}, "email_address": "' + mail + '"} } ], "items": [ { "name": "' + this.title + '", "description": "Das online Workout von zuhause.", "quantity": "1", "unit_amount": { "currency_code": "EUR", "value": "' + this.netPrice + '" }, "tax": { "name": "MwSt.", "percent": "' + this.tax + '" }, "unit_of_measure": "QUANTITY" } ] }'


    this.http.post<any>(this.ppUrl + '/v2/invoicing/invoices', invoice, { headers: headers })
      .subscribe(data => {
        this.invoiceURI = Object(data)["href"];
        console.log("Invoice created")
        this.sendInvoice()
      })
  }

  private sendInvoice() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.ppAccessToken,
    });

    this.http.post<any>(this.invoiceURI + '/send', undefined, { headers: headers })
      .subscribe(data => {
        this.invoiceLinkforCustomer = Object(data)["href"];
        console.log("Invoice sended", this.invoiceLinkforCustomer)
        this.markInvoiceAsPaid()
      })
  }

  private markInvoiceAsPaid() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.ppAccessToken,
    });

    let paymentDetails = '{ "method": "CASH", "date": "' + new Date().toISOString().slice(0, 10) + '", "amount": { "currency_code": "EUR", "value": "' + this.price + '"}}'

    this.http.post<any>(this.invoiceURI + '/payments', paymentDetails, { headers: headers })
      .subscribe(data => {
        console.log("Invoice paid");
        window.open(this.invoiceLinkforCustomer, '_blank');
        this.paypalModal.hide();
        this.success.emit(this.invoiceLinkforCustomer);
      })

      this.send(this.destination,this.firstName,this.lastName)
  }

  show(title, meetingId) {
    this.title = title;
    this.meetingId = meetingId;
    this.paypalModal.show();
  }

  hide() {
    this.paypalModal.hide();
  }

  send(destination, firstName, lastName) {
    this.zoomService.getMeeting(this.meetingId)
      .toPromise()
      .then((data: any) => {
        if (data.join_url) {
          console.log(data.join_url)
          this.sendMail(destination, firstName, lastName, data.join_url);
        } else {
          console.log(data)
        }
      }).catch((error) => {
        console.log(error)
      })
  }

  sendMail(destination, firstName, lastName, meetingId) {
    let copy = "info@reha-sportstudio.de";
    let bcc;
    // let copy = '';
    // let bcc = "kasi_1991@hotmail.de";

    this.mailService.sendMessage(destination, this.title, firstName, lastName, copy, bcc, meetingId, undefined)
      .subscribe(
        data => {
          console.log(data);
        }, error => {
          console.log("Error:", error);
        })
  }
}
